import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Menu from "@insite/mobius/Menu";
import Popover from "@nishtech/Components/OSBPHeaderPopoverV2";
import HeaderMenuLinkManager from "@nishtech/Components/HeaderMenuLinkManager";
import { MainNavigationStyles, MappedLink } from "@nishtech/Overrides/Widgets/Header/MainNavigation";
import CustomApplicationState from "@nishtech/Store/Nishtech/Data/CustomApplicationState/CustomApplicationState";
import * as React from "react";
import { ThemeProps, withTheme } from "styled-components";

interface OwnProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement | null>;
    isOpen: boolean;
    isAuth: boolean;
    // toggleLogin: Function;
    displayChangeCustomerLink: boolean;
    zoneId: string;
}

type Props = ThemeProps<BaseTheme> & OwnProps & ReturnType<typeof mapStateToProps>;

// type Props = ThemeProps<BaseTheme> & OwnProps;
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        popover: state.NishtechGlobalData.ClosePopOverStore.closeMenuPopover,
    };
};
class MainNavigationItem extends React.Component<Props> {
    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();

    // componentDidUpdate(prevProps: Readonly<Props>) {
    //     if (this.props.isOpen && !prevProps.isOpen) {
    //         this.openPopover();
    //     } else if (!this.props.isOpen && prevProps.isOpen) {
    //         this.closePopover();
    //     }
    // }

    // closePopover = () => {
    //     this.popover.current && (this.popover.current! as any).closePopover();
    // };

    // openPopover = () => {
    //     this.popover.current && (this.popover.current! as any).openPopover();
    // };
    state = {
        activeTab: "",
    };
    componentDidUpdate(prevProps: Readonly<Props>) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.openPopover();
        } else if (!this.props.isOpen && prevProps.isOpen) {
            this.closePopover();
        }

        if (this.props.popover !== prevProps.popover) {
            this.closePopover();
        }
    }

    closePopover = () => {
        const menuLink = document.querySelector(".menu-item.activeTab");
        if (menuLink) {
            menuLink.classList.remove("activeTab");
        }
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        var getSelectBox = document.getElementById("coveoPagerSortTypeSelector");
        if (getSelectBox) {
            getSelectBox.blur();
        }

        this.popover.current && (this.popover.current! as any).openPopover();
    };

    handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement | HTMLUListElement, MouseEvent>) => {
        this.openPopover();
        this.setState({ activeTab: e.currentTarget.id.split("_")[1] });

        const searchinputPopover = document.getElementById("headerSearch-popover");
        const searchinputPopoverOverlay = document.getElementById("overlay-div");

        if (searchinputPopover && searchinputPopoverOverlay) {
            searchinputPopover.style.display = "none";
            searchinputPopoverOverlay.style.display = "none";
        }
    };

    handleMouseLeave = (e: React.MouseEvent<HTMLAnchorElement | HTMLUListElement, MouseEvent>) => {
        this.setState({ activeTab: "" });
    };

    handleKeyDown = (e: any) => {
        // alert("clicked");
        if (e.key === "Enter" || e.keyCode === 13) {
            this.openPopover();
            this.setState({ activeTab: e.currentTarget.id.split("_")[1] });
            const searchinputPopover = document.getElementById("headerSearch-popover");
            const searchinputPopoverOverlay = document.getElementById("overlay-div");

            if (searchinputPopover && searchinputPopoverOverlay) {
                searchinputPopover.style.display = "none";
                searchinputPopoverOverlay.style.display = "none";
            }
        }
    };

    render() {
        const {
            styles,
            link,
            index,
            isOpen,
            isAuth,
            zoneId,
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading =
            hasChildren && (link.childrenType === "CascadingMenu" || link.childrenType === "CustomLinkList");
        const isMega = hasChildren && link.childrenType === "MegaMenu";
        const isActive = link.title === this.state.activeTab;
        const generateUrl = () => {
            if (!isAuth && link.isLoggedInRequired) {
                // toggleLogin({ loginDrawer: true });
            } else {
                window.location.href = link.url;
            }
        };
        let menuLink = (
            <>
                {link.title !== "Service" && (
                    <Link
                        className={`menu-item ${isActive ? "activeTab" : ""}`}
                        data-test-selector="megaMenuHover"
                        typographyProps={styles.menuItemTypography}
                        color={styles.menuItemTypography?.color}
                        {...styles.menuItem}
                        onClick={generateUrl}
                        target={link.openInNewWindow ? "_blank" : ""}
                        hoverStyle={{
                            textDecoration: isActive ? "underline #020508 4px" : "none",
                        }}
                    >
                        {link.title}
                        {isCascading && downIcon}
                    </Link>
                )}
            </>
        );
        if (isMega || link.url === "") {
            menuLink = (
                <Link
                    className={`menu-item ${isActive ? "activeTab" : ""}`}
                    data-test-selector="megaMenuHover"
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                    hoverStyle={{
                        textDecoration: isActive ? "underline #020508 4px" : "none",
                    }}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                    onKeyDown={this.handleKeyDown}
                >
                    {link.title}
                    {(isCascading || isMega) && downIcon}
                    <Hidden below="lg">
                        <StyledWrapper className="menuLeftHover"></StyledWrapper>
                        <StyledWrapper className="menuRightHover"></StyledWrapper>
                    </Hidden>
                </Link>
            );
        }

        let menuItem = menuLink;

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <Menu
                    className="cascading-menu"
                    data-test-selector={`mainNavigationItem_${index}`}
                    isOpen={isOpen || undefined}
                    descriptionId={`${link.title}_${index}`}
                    menuItems={link.children}
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    {...menuProps}
                    {...styles.cascadingMenu}
                />
            );
        }

        if (isMega) {
            menuItem = (
                <Popover
                    data-test-selector="megaMenuHover"
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    contentBodyProps={{
                        ...styles.megaMenu?.contentBodyProps,
                        _width: 1140,
                        as: "div",
                    }}
                    controlsId={`${index}_${link.title}`}
                    ref={this.popover}
                    positionFunction={(element: React.RefObject<HTMLUListElement | null>) => {
                        if (this.props.container.current) {
                            const parentPosition = this.props.container.current.getBoundingClientRect();
                            const rect = element.current?.getBoundingClientRect();
                            const top = rect ? rect.top + (rect.height > 100 ? styles.menuHeight : rect.height) : 0;
                            const offsetTop = top;
                            const cartWidth = 150;
                            const breakpointMaxWidth = maxWidths.find((value: number, index: number) => {
                                return (
                                    parentPosition.width + cartWidth <= value &&
                                    parentPosition.width + cartWidth > maxWidths[index - 1]
                                );
                            });

                            const width = breakpointMaxWidth ? breakpointMaxWidth - 30 : parentPosition.width;

                            return {
                                top: `${offsetTop}px`,
                                //left:"0px",
                                position: "fixed",
                                width: `100%`,
                                maxWidth: "900px",
                                overflow: "hidden auto",
                                minWidth: "700px",
                                height: "auto",
                                // left: "50%",
                                // transform: "translateX(-50%)"
                            };
                        }
                        return {
                            position: "absolute",
                        };
                    }}
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                    // onMouseOver={e => this.handleMouseEnter(e)}
                    // onMouseLeave={this.handleMouseLeave}
                    onMouseEnter={this.handleMouseEnter} // Handle popover hover
                    onMouseLeave={this.handleMouseLeave} // Handle popover leave
                >
                    <GridContainer
                        className="mega-menu-grid-container"
                        data-test-selector={`mainNavigationItem_${index}`}
                        {...styles.megaMenuGridContainer}
                        offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                    >
                        <HeaderMenuLinkManager
                            zoneId={zoneId}
                            link={link}
                            styles={styles}
                            onHandleClose={this.closePopover}
                        />
                    </GridContainer>
                </Popover>
            );
        }

        return menuItem;
    }
}

export default withTheme(MainNavigationItem);
